import React, { useState, useRef, useEffect } from 'react';
import { BsChevronDown } from 'react-icons/bs';
import './StatusDropdown.css';

const StatusDropdown = ({ 
    value, 
    onChange, 
    options = [],
    disabled = false,
    size = 'medium',
    placeholder = 'Select Status',
  
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Default options if none provided
    const defaultOptions = [
        { value: 'assigned', label: 'Assigned', color: '#2563EB', bgColor: '#EFF6FF' },
        { value: 'unassigned', label: 'Unassigned', color: '#6B7280', bgColor: '#F9FAFB' },
        { value: 'active', label: 'Active', color: '#059669', bgColor: '#ECFDF5' },
        { value: 'inactive', label: 'Inactive', color: '#991B1B', bgColor: '#FEF2F2' },
    ];

    const statusOptions = options.length > 0 ? options : defaultOptions;
    
    // Get current selected option
    const selectedOption = statusOptions.find(opt => opt.value === value);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleToggle = () => {
        if (!disabled) {
            setIsOpen(!isOpen);
        }
    };

    const handleSelect = (option) => {
        onChange(option.value);
        setIsOpen(false);
    };

    const sizeClass = `status-dropdown-${size}`;

    return (
        <div 
            className={`status-dropdown ${sizeClass} ${disabled ? 'disabled' : ''}`} 
            ref={dropdownRef}
        >
            <button
                type="button"
                className={`status-dropdown-trigger ${isOpen ? 'open' : ''}`}
                onClick={handleToggle}
                disabled={disabled}
                style={{
                    backgroundColor: selectedOption?.bgColor || '#F3F4F6',
                    color: selectedOption?.color || '#4B5563',
                }}
            >
                <span className="status-dropdown-label">
                    {selectedOption?.label || placeholder}
                </span>
                <BsChevronDown 
                    className={`status-dropdown-icon ${isOpen ? 'rotate' : ''}`}
                    size={14}
                />
            </button>

            {isOpen && (
                <div className="status-dropdown-menu">
                    {statusOptions.map((option) => (
                        <div
                            key={option.value}
                            className={`status-dropdown-option ${
                                value === option.value ? 'selected' : ''
                            }`}
                            onClick={() => option.value != value && handleSelect(option)}
                            style={{
                                '--option-color': option.color,
                                '--option-bg': option.bgColor,
                            }}
                            disabled={option.value == value}
                        >
                            <span 
                                className="status-option-indicator"
                                style={{
                                    backgroundColor: option.color,
                                }}
                            />
                            <span className="status-option-label">
                                {option.label}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default StatusDropdown;